module.exports = __webpack_public_path__ + "static/media/SVG_edit.9ce4b4ef.svg";